var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAudioWave = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 17.6548,
    height: 20,
    viewBox: "0 0 17.6548 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "audio-wave"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.11132 3.426C0.497329 3.426 0 3.92333 0 4.53733V15.4613C0 16.0753 0.497329 16.5727 1.11132 16.5727C1.72532 16.5727 2.22265 16.0753 2.22265 15.4613V4.53733C2.22265 3.92333 1.72532 3.426 1.11132 3.426Z",
    fill: "#850064"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.96921 5.9314C4.35521 5.9314 3.85788 6.42873 3.85788 7.04273V12.9561C3.85788 13.5701 4.35521 14.0674 4.96921 14.0674C5.5832 14.0674 6.08053 13.5701 6.08053 12.9561V7.04273C6.08053 6.42873 5.5832 5.9314 4.96921 5.9314Z",
    fill: "#850064"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.82761 0C8.21361 0 7.71628 0.497333 7.71628 1.11133V18.8887C7.71628 19.5027 8.21361 20 8.82761 20C9.4416 20 9.93893 19.5027 9.93893 18.8887V1.11133C9.93893 0.497333 9.4416 0 8.82761 0Z",
    fill: "#850064"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.685 3.42671C12.071 3.42671 11.5737 3.92404 11.5737 4.53804V15.462C11.5737 16.076 12.071 16.5734 12.685 16.5734C13.299 16.5734 13.7963 16.076 13.7963 15.462V4.53804C13.7963 3.92404 13.299 3.42671 12.685 3.42671Z",
    fill: "#850064"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.5434 5.31398C15.9294 5.31398 15.4321 5.81131 15.4321 6.42531V13.574C15.4321 14.188 15.9294 14.6853 16.5434 14.6853C17.1574 14.6853 17.6547 14.188 17.6547 13.574V6.42531C17.6547 5.81131 17.1574 5.31398 16.5434 5.31398Z",
    fill: "#850064"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAudioWave);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/audio-wave.f1ca6db9351190de28c608826290a35e.svg";